{
  "modal": {
    "title": "Varaa",
    "recurringReservation": "Vakiovuoro",
    "singleReservation": "Yksittäinen vuoro",
    "saunaRulesLink": "Säännöt",
    "commonAreaRulesLink": "Säännöt",
    "commonAreaTermsLink": "Varausehdot",
    "acceptRules": "Hyväksyn säännöt ja varausehdot",
    "cancel": "Peruuta",
    "confirm": "Vahvista",
    "reserveButton": "Varaa",
    "paymentButton": "Maksamaan",
    "reservationLimitWarning": "Sinulla on enimmäismäärä vuoroja varattuna. Jos haluat vaihtaa vuoroa, sinun tulee ensin perua voimassa oleva vuorosi.",
    "sendConfirmationEmail": "Lähetä vahvistusviesti varauksesta sähköpostiini",
    "confirmationEmailOffWarningFree": "Löydät varaukseen liittyvät tiedot asukassivuilta.",
    "confirmationEmailOffWarningPaid": "Löydät varaukseen liittyvät tiedot asukassivuilta. Maksuvahvistus lähetetään sähköpostiin aina."
  },
  "success": {
    "title": "Varaus onnistui!"
  },
  "payment": {
    "succeeded": "Varauksen maksaminen onnistui!",
    "failed": "Varauksen maksaminen epäonnistui!",
    "failedMessage": "Yritä uudelleen tai ota yhteys asiakaspalveluun.",
    "singleReservation": "Yksittäisvaraus"
  },
  "error": {
    "reservationFailed": "Varauksen tekeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
    "overlap": "Valittu varaus on ristiriidassa olemassa olevan varauksen kanssa. Valitse toinen aika tai peru nykyinen varaus.",
    "contractEndDate": "Varauksen ajankohta ei voi olla sopimuksen päättymispäivää myöhemmin.",
    "contractEndDateStart": "Varaus ei voi alkaa sopimuksen päättymispäivän jälkeen.",
    "contractEndBeforeReservationStart": "Sopimuksen päättymispäivä on ennen valitun varauksen alkua.",
    "reservationEndBeforeStart": "Varauksen päättymispäivän on oltava sama tai myöhempi kuin alkamispäivä.",
    "reservationStartBeforeContractStart": "Varaus ei voi alkaa ennen sopimuksen alkamispäivää.",
    "contractContinuousNotAllowed": "Toistaiseksi voimassa olevaa varausta ei voi tehdä sopimukseen, jolla on päättymispäivä.",
    "maxReservedSlotsPerWeek": "Sopimuksen viikoittainen varausraja on ylittynyt.",
    "invalidSlotGridPosition": "Varauksen vuorot eivät ole sallittuina aikoina.",
    "conflict": "Varausta ei voitu tehdä valitulle vuorolle. Valitse toinen aika tai ota yhteyttä asiakaspalveluun.",
    "slotAlreadyStarted": "Varausta ei voi tehdä vuorolle joka on jo alkanut.",
    "commonError": "Tapahtui virhe, yritä hetken kuluttua uudelleen.",
    "reloadButton": "Lataa uudelleen",
    "oops": "Hups"
  },
  "cancelModal": {
    "title": "Varauksen tiedot",
    "recurringWarning": "Tämä on toistuva varaus. Perumalla tämän varauksen perut myös kaikki sarjan tulevat varaukset.",
    "terminateWarning": "Päättämällä varauksen, kaikki tästä päivästä eteenpäin olevat varaukset poistetaan.",
    "effectiveFrom": "Muutos astuu voimaan: {{date}}",
    "recurringInfo": "Vakiovuoro {{weekday}} klo {{timeRange}}, {{date}} alkaen",
    "singleNotAllowed": "Et voi perua tätä varausta. Ota yhteyttä asiakaspalveluun.",
    "sameDayNotAllowed": "Et voi perua saman päivän varausta",
    "terminateSameDayNotAllowed": "Toistuvaa varausta ei voi päättää samalle päivälle.",
    "cancelFailed": "Varauksen peruminen epäonnistui. Yritä hetken kuluttua uudelleen.",
    "recurringCancelNotAllowed": "Toistuvaa varausta ei voi perua, jos se on jo alkanut.",
    "notAllowed": "Ei sallittu",
    "cancel": "Peruuta",
    "confirmSingle": "Peru varaus",
    "confirmRecurring": "Peru varaukset",
    "confirmTerminate": "Päätä varaus",
    "successSingle": "Varaus peruttu",
    "successRecurring": "Varaukset peruttu",
    "successTerminated": "Varaus päätetty",
    "contractTerminated": "Varausta ei voi perua tai päättää, koska sopimus on päätetty.",
    "reservationTitle": "Varauksen tiedot"
  },
  "legend": {
    "freeSlot": "Vapaa vuoro",
    "reservedSlot": "Varattu vuoro",
    "ownReservation": "Oma vuoro",
    "ownSingleReservation": "Oma yksittäinen vuoro"
  },
  "timeFormatting": {
    "everyWeek": "joka viikko",
    "atTime": "klo",
    "weekdayWithTimeRange": "{{weekday}} klo {{timeRange}}",
    "weekdayDateWithTimeRange": "{{weekday}} {{date}} klo {{timeRange}}",
    "dateWithTimeRange": "{{date}} klo {{timeRange}}",
    "startingFrom": "alkaen",
    "beginningFrom": "Alkaen:",
    "priceAddedToContract": "lisätään sopimuksellesi",
    "recurringType": "Vakiovuoro",
    "singleType": "Yksittäisvuoro",
    "recurringCancelled": "Vakiovuoro peruttu",
    "recurringTerminated": "Vakiovuoro päätetty",
    "singleCancelled": "Yksittäisvuoro peruttu",
    "hasCancelled": "on peruttu",
    "hasTerminated": "on päätetty",
    "recurringUnitPrice": "Hinta {{price}}€/kpl/kk",
    "singleUnitPrice": "Hinta {{price}}€/kerta",
    "upcomingRecurringUnitPrice": "Uusi hinta {{price}}€/kpl/kk alkaen {{date}}.",
    "priceAddedToContractFromDate": "lisätään sopimuksellesi {{date}} alkaen.",
    "payOn3rdParty": "maksetaan ulkoisessa palvelussa"
  },
  "weekdays": {
    "monday": "Ma",
    "tuesday": "Ti",
    "wednesday": "Ke",
    "thursday": "To",
    "friday": "Pe",
    "saturday": "La",
    "sunday": "Su"
  },
  "equipmentCategories": {
    "washing_machine": "Pesukone",
    "allergy_washing_machine": "Allergiapesukone",
    "dryer": "Kuivausrumpu",
    "mangle": "Mankeli"
  },
  "filters": {
    "allEquipment": "Kaikki pesulaitteet",
    "laundryRoom": "Pesutupa",
    "washingMachines": "Pesukoneet",
    "dryers": "Kuivausrummut",
    "allSaunas": "Kaikki saunat",
    "sauna": "Saunat",
    "mangles": "Mankelit"
  },
  "myReservations": "Omat varaukset",
  "pageTitle": "Pesulavaraukset",
  "pageTitleSauna": "Saunavuorot",
  "pageTitleGym": "Kuntosalivaraukset",
  "pageTitleCommonAreas": "Kokoontumistilat",
  "commonAreaSidebarDescription": "Täällä voit tarkastella kokoontumistilojen varauksia ja varata oman vuoron valitsemalla vapaan ajan",
  "noCalendarsAvailable": "Ei varauskalentereita saatavilla valitulla viikolla",
  "noReservableEquipment": "Ei varattavia laitteita",
  "saunaSidebarDescription": "Täällä voit tarkastella saunavuoroja ja varata oman saunavuoron valitsemalla vapaan ajan tai painamalla Varaa",
  "gymSidebarDescription": "Täällä voit tarkastella kuntosalivuoroja ja varata oman vuoron valitsemalla vapaan ajan",
  "pincode": "PIN-koodi: {{pincode}}",
  "loadingPincode": "Ladataan PIN-koodia...",
  "pincodeLoadError": "PIN-koodin lataaminen epäonnistui"
}
